"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spanishTranslation = {
    asideOrderSummaryTitle: 'Resumen del pedido',
    asidePromoAddLink: 'Añadir código de promoción',
    asidePromoAppliedLabel: 'Añadir código de promoción',
    asidePromoRemove: 'eleminar código de promoción',
    asidePromoInputLabel: 'Añadir un código de promoción',
    asidePromoCancel: 'cancelar',
    asidePromoApply: 'Aplicar',
    asideSubtotal: 'Subtotal',
    asideShipping: 'Envio',
    asideShippingQuestionsLink: '¿Preguntas sobre el envío gratis?',
    asideShippingQuestionsText: 'Los productos dentro de las categorías de Libros, Biblias, Escuela Bíblica de Vacaciones (se aplican algunas exclusiones) y artículos para la iglesia califican para envío gratis con un pedido mínimo de $50.',
    asideShippingQuestionsNote: 'Nota',
    asideShippingQuestionsNoteText: 'Si se incluyen productos fuera de estas categorías en tu pedido, se aplicarán cargos de envío para esos productos.',
    asideShippingQuestionsExclusionsLink: 'ver más detalles y exclusiones',
    asideGiftCards: 'Tarjetas de regalo',
    asideCalculated: 'calcular al salir',
    asideTax: 'Impuesto',
    asidePromo: 'Promoción',
    asideTotal: 'Total',
    checkoutButtonText: 'Pago Seguro',
    asideQuickAddLabel: 'Añadir artículo al carrito por ID de producto',
    asideQuickAddButtonText: 'Añadir',
    asideQuickAddErrorText: 'No se pudo encontrar el artículo. Por favor chequea el número del artículo y prueba de nuevo',
    asidePlaceOrderButtonText: 'Procesar orden',
    asidePlaceOrderNoteText: 'Al presionar "Procesar orden" estás confirmando que estás de acuerdo con nuestros ',
    asidePlaceOrderNoteTermsLink: 'términos y condiciones',
    asidePlaceOrderNoteAnd: 'y',
    asidePlaceOrderNotePolicyLink: 'política de privicidad',
};
exports.default = spanishTranslation;
